module.exports = __webpack_public_path__ + "img/cl_five_steps_1_upload.e373dd97.png";